export default () => {
  const $clientAutocomplete = $("#client_autocomplete_selected_client");

  if ($clientAutocomplete.length) {
    const fillClientInformation = () => {
      if ($clientAutocomplete.val()) {
        const clientData = JSON.parse($clientAutocomplete.val());
        $("#incident_report_client_first_name").val(clientData.first_name);
        $("#incident_report_client_last_name").val(clientData.last_name);
        $("#incident_report_client_dob").val(clientData.dob);
        $("#incident_report_client_id").val(clientData.id);
      } else {
        $("#incident_report_client_first_name").val("");
        $("#incident_report_client_last_name").val("");
        $("#incident_report_client_dob").val("");
        $("#incident_report_client_id").val("");
      }
    };

    $clientAutocomplete.on("change", fillClientInformation);

    // Trigger the change event manually to run the listener on mount
    fillClientInformation();
  }
};
